import React from 'react';
import { Filter, SearchInput, SelectInput } from 'react-admin';

class FiltreAgExp extends React.Component {

    /*
    state={l_ag_dest:[],roles:''};

    componentDidMount(){
        var list_ag_dest=JSON.parse(localStorage.getItem('trans_list_ag_dest'));
        list_ag_dest=_.orderBy(list_ag_dest, ['name'],['asc']);

        this.setState({l_ag_dest:list_ag_dest,roles:localStorage.getItem('roles')},()=>{});
     }
     */

render() {
    //const {l_ag_dest,roles}=this.state;
    return (
        <Filter {...this.props} >
            <SearchInput source="q"  alwaysOn />

            <SelectInput
                source="etat"
                label="Status" 
                choices={[
                    { id: 'attente', name: 'Attentes' },
                    { id: 'approb_man_exp', name: 'Approuvés' },
                    { id: 'termine', name: 'Payés' },
                    { id: 'credit_status', name: 'Crédits' }
                ]}
            />
        </Filter>
    );

    }
}

export default FiltreAgExp;